const translation = {
  pageTitle: 'Hey, lass uns anfangen!👋',
  welcome: 'Willkommen bei Dify, bitte melde dich an, um fortzufahren.',
  email: 'E-Mail-Adresse',
  emailPlaceholder: 'Deine E-Mail',
  password: 'Passwort',
  passwordPlaceholder: 'Dein Passwort',
  name: 'Benutzername',
  namePlaceholder: 'Dein Benutzername',
  forget: 'Passwort vergessen?',
  signBtn: 'Anmelden',
  installBtn: 'Einrichten',
  setAdminAccount: 'Admin-Konto einrichten',
  setAdminAccountDesc: 'Maximale Berechtigungen für das Admin-Konto, das verwendet werden kann, um Anwendungen zu erstellen und LLM-Anbieter usw. zu verwalten.',
  createAndSignIn: 'Erstellen und anmelden',
  oneMoreStep: 'Nur noch ein Schritt',
  createSample: 'Basierend auf diesen Informationen erstellen wir eine Beispielanwendung für dich',
  invitationCode: 'Einladungscode',
  invitationCodePlaceholder: 'Dein Einladungscode',
  interfaceLanguage: 'Oberflächensprache',
  timezone: 'Zeitzone',
  go: 'Zu Dify gehen',
  sendUsMail: 'Sende uns deine Vorstellung per E-Mail, und wir bearbeiten die Einladungsanfrage.',
  acceptPP: 'Ich habe die Datenschutzbestimmungen gelesen und akzeptiere sie',
  reset: 'Bitte führe den folgenden Befehl aus, um dein Passwort zurückzusetzen',
  withGitHub: 'Mit GitHub fortfahren',
  withGoogle: 'Mit Google fortfahren',
  rightTitle: 'Das volle Potenzial von LLM ausschöpfen',
  rightDesc: 'Mühelos optisch ansprechende, bedienbare und verbesserbare KI-Anwendungen erstellen.',
  tos: 'Nutzungsbedingungen',
  pp: 'Datenschutzbestimmungen',
  tosDesc: 'Mit der Anmeldung stimmst du unseren',
  goToInit: 'Wenn du das Konto noch nicht initialisiert hast, gehe bitte zur Initialisierungsseite',
  donthave: 'Hast du nicht?',
  invalidInvitationCode: 'Ungültiger Einladungscode',
  accountAlreadyInited: 'Konto bereits initialisiert',
  error: {
    emailEmpty: 'E-Mail-Adresse wird benötigt',
    emailInValid: 'Bitte gib eine gültige E-Mail-Adresse ein',
    nameEmpty: 'Name wird benötigt',
    passwordEmpty: 'Passwort wird benötigt',
    passwordInvalid: 'Das Passwort muss Buchstaben und Zahlen enthalten und länger als 8 Zeichen sein',
  },
  license: {
    tip: 'Bevor du mit Dify Community Edition beginnst, lies die',
    link: 'Open-Source-Lizenz',
  },
  join: 'Beitreten',
  joinTipStart: 'Lade dich ein, dem',
  joinTipEnd: 'Team auf Dify beizutreten',
  invalid: 'Der Link ist abgelaufen',
  explore: 'Dify erkunden',
  activatedTipStart: 'Du bist dem',
  activatedTipEnd: 'Team beigetreten',
  activated: 'Jetzt anmelden',
  adminInitPassword: 'Admin-Initialpasswort',
  validate: 'Validieren',
}

export default translation
